import DocumentTitle from 'react-document-title';
import React from 'react';

import DefaultLayout from './layouts/DefaultLayout';
import PostLayout from './layouts/PostLayout';

export default class MarkdownWrapper extends React.Component {
  render() {
    const post = this.props.page.data;
    return (
      <DocumentTitle title={`${post.title} | ${this.props.config.siteTitle}`}>
        {
          post.layout === 'post' ?
            <PostLayout post={post} /> :
            <DefaultLayout post={post} />
        }
      </DocumentTitle>
    );
  }
}



/** WEBPACK FOOTER **
 ** ../wrappers/md.jsx
 **/